"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressValidationDataTransformer = void 0;
var tslib_1 = require("tslib");
var module_util_1 = require("../../utils/module.util");
// import { getCities_bff } from './bff';
var jericho_1 = require("./jericho");
var searchCities_1 = tslib_1.__importDefault(require("./oneGraph/searchCities"));
var interfaces_1 = require("../common/interfaces");
var index_1 = require("../common/index");
var addressValidationApi = (0, module_util_1.getModules)({
    /**
     * @deprecated use `searchCities`
     */
    getCities: {
        jerichoFn: jericho_1.getCities_jericho,
        bffFn: jericho_1.getCities_jericho,
    },
    searchCities: {
        jerichoFn: searchCities_1.default,
        bffFn: searchCities_1.default,
    },
});
var addressValidationDataTransformer = function (result) {
    var responseData = result.data;
    var errors = null;
    if (responseData.error) {
        errors = (0, index_1.addErrorType)([responseData.error], interfaces_1.ErrorType.SERVER);
        responseData.error = errors[0];
    }
    return {
        errors: errors,
        data: responseData,
    };
};
exports.addressValidationDataTransformer = addressValidationDataTransformer;
exports.default = addressValidationApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/addressValidationApi/index.js
// module id = 624
// module chunks = 11